var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"value":_vm.value,"menu-props":{ offsetY: true }},on:{"input":_vm.onInput}},'v-select',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }